export const LOCATIONS = ["Mary's House", "Ivy League", "Grace Care", "The Hangout"];
export const ROLES = ["Employee", "Manager", "HR", "Director"];
export const DEMO_PASSWORD = process.env.REACT_APP_DEMO_PASSWORD || "";

export const REQUEST_TYPES = [
  "Reward Redemption",
  "Employee Recognition",
  "Special Request",
  "HR Request",
  "Other",
];

export const STATUSES = [
  "Draft",
  "Submitted",
  "Manager Reviewed",
  "HR Approved",
  "HR Denied",
  "Sent Back for More Info",
  "Director Approved",
  "Director Denied",
  "Completed",
];

export const STATUS_STYLES = {
  Draft: { bg: "#34302A", text: "#B0A899", label: "Draft" },
  Submitted: { bg: "#2D3A4A", text: "#9CC4E4", label: "Submitted" },
  "Manager Reviewed": { bg: "#3A3320", text: "#E4CF8A", label: "Manager Reviewed" },
  "HR Approved": { bg: "#233A2A", text: "#86E0A1", label: "HR Approved" },
  "HR Denied": { bg: "#3A2323", text: "#E08686", label: "HR Denied" },
  "Sent Back for More Info": { bg: "#3A3320", text: "#E4CF8A", label: "Sent Back" },
  "Director Approved": { bg: "#23341f", text: "#bce04b", label: "Director Approved" },
  "Director Denied": { bg: "#3A2323", text: "#E08686", label: "Director Denied" },
  Completed: { bg: "#DCE34B", text: "#211D18", label: "Completed" },
};
